import React, { useState } from "react";
import styled from "styled-components";
import { CSSTransition } from 'react-transition-group';

import Divider from "../core/Divider";
import Flex from "../core/Flex";
import Space from "../core/Space";
import FormText from "../form/FormText";
import useViewStore from "../../store/useViewStore";

const Footer = ({ children }) => {
  const { isPadView } = useViewStore((state) => state);
  const [isOpenMenu1, setIsOpenMenu1] = useState(false);
  const [isOpenMenu2, setIsOpenMenu2] = useState(false);
  const [isOpenMenu3, setIsOpenMenu3] = useState(false);
  const [isOpenMenu4, setIsOpenMenu4] = useState(false);
  const [isOpenMenu5, setIsOpenMenu5] = useState(false);

  const toggleClick = (value) => {
    setIsOpenMenu1(isOpenMenu1 ? false : value === 1);
    setIsOpenMenu2(isOpenMenu2 ? false : value === 2);
    setIsOpenMenu3(isOpenMenu3 ? false : value === 3);
    setIsOpenMenu4(isOpenMenu4 ? false : value === 4);
    setIsOpenMenu5(isOpenMenu5 ? false : value === 5);
  };

  if (isPadView) {
    return (
      <BXFooterMobile>
        <FooterTitleContainerMobile onClick={() => { toggleClick(1) }}>
          <FooterTitleMobile>關於藍十字</FooterTitleMobile>
          <FooterIconMobile $isOpen={isOpenMenu1} />
        </FooterTitleContainerMobile>

        <CSSTransition
          in={isOpenMenu1}
          timeout={250}
          classNames="slide"
          unmountOnExit
        >
          <FooterContentMobile>
            <FooterLink href="https://www.bluecross.com.hk/cn/AboutBlueCross/Information/CompanyProfile">公司簡介</FooterLink>
            <FooterLink href="https://www.bluecross.com.hk/cn/AboutBlueCross/Information/CompanyNews">公司動向</FooterLink>
            <FooterLink href="https://www.bluecross.com.hk/cn/AboutBlueCross/Information/SocialResponsibility">企業社會責任</FooterLink>
            <FooterLink href="https://www.bluecross.com.hk/cn/Fencing/Information">全力支持劍擊運動</FooterLink>
            <FooterLink href="https://www.bluecross.com.hk/cn/AboutBlueCross/Information/NewsRoom">新聞中心</FooterLink>
            <FooterLink href="https://www.bluecross.com.hk/cn/AboutBlueCross/Information/InTheNews">傳媒報導</FooterLink>
            <FooterLink href="https://www.bluecross.com.hk/cn/AboutBlueCross/Information/VideoReview">片段重溫</FooterLink>
            <FooterLink href="https://www.bluecross.com.hk/cn/AboutBlueCross/Information/CompanyAwards">公司獎項</FooterLink>
            <FooterLink href="https://www.bluecross.com.hk/cn/career-opportunities/Information">就業機會</FooterLink>
          </FooterContentMobile>
        </CSSTransition>

        <FooterTitleContainerMobile onClick={() => { toggleClick(2) }}>
          <FooterTitleMobile>聯絡我們</FooterTitleMobile>
          <FooterIconMobile $isOpen={isOpenMenu2} />
        </FooterTitleContainerMobile>

        <CSSTransition
          in={isOpenMenu2}
          timeout={250}
          classNames="slide"
          unmountOnExit
        >
          <FooterContentMobile>
            <Flex>
              <FooterIcon>
                <img src={`${process.env.PUBLIC_URL}/images/call.png`} alt="call" />
              </FooterIcon>
              <FooterLink href="tel:+85228396333">電話：(852) 2839 6333</FooterLink>
            </Flex>
            <Flex>
              <FooterIcon>
                <img src={`${process.env.PUBLIC_URL}/images/email.png`} alt="email" />
              </FooterIcon>
              <FooterLink href="mailto:CS@bluecross.com.hk">電郵：CS@bluecross.com.hk</FooterLink>
            </Flex>
            <Flex>
              <FooterIcon>
                <img src={`${process.env.PUBLIC_URL}/images/fax.png`} alt="fax" />
              </FooterIcon>
              <FooterText>傳真：(852) 2263 7517</FooterText>
            </Flex>
            <Flex>
              <FooterIcon style={{ marginTop: 7 }}>
                <img src={`${process.env.PUBLIC_URL}/images/clock.png`} alt="clock" />
              </FooterIcon>
              <FooterTitle style={{ marginBottom: 0 }}>客戶服務時間</FooterTitle>
            </Flex>
            <FooterText>星期一至星期五</FooterText>
            <FooterText>上午9時至下午5時30分</FooterText>
            <FooterText>星期六、日及公眾假期休息</FooterText>
            <Flex>
              <FooterIcon style={{ marginTop: 7 }}>
                <img src={`${process.env.PUBLIC_URL}/images/address.png`} alt="address" />
              </FooterIcon>
              <FooterTitle style={{ marginBottom: 0 }}>地址:</FooterTitle>
            </Flex>
            <FooterText>香港灣仔皇后大道東183號</FooterText>
            <FooterText>合和中心54樓</FooterText>
          </FooterContentMobile>
        </CSSTransition>

        <FooterTitleContainerMobile onClick={() => { toggleClick(3) }}>
          <FooterTitleMobile>網誌</FooterTitleMobile>
          <FooterIconMobile $isOpen={isOpenMenu3} />
        </FooterTitleContainerMobile>

        <CSSTransition
          in={isOpenMenu3}
          timeout={250}
          classNames="slide"
          unmountOnExit
        >
          <FooterContentMobile>
            <FooterLink href="https://just-right.bluecross.com.hk/blog/all">所有主題</FooterLink>
            <FooterLink href="https://just-right.bluecross.com.hk/blog/health">健康智識</FooterLink>
            <FooterLink href="https://just-right.bluecross.com.hk/blog/life">智式生活</FooterLink>
            <FooterLink href="https://just-right.bluecross.com.hk/blog/pet">智寵您</FooterLink>
            <FooterLink href="https://just-right.bluecross.com.hk/blog/travel">智遊天下</FooterLink>
            <FooterLink href="https://just-right.bluecross.com.hk/blog/protection">保障啱啱好</FooterLink>
          </FooterContentMobile>
        </CSSTransition>

        <FooterTitleContainerMobile onClick={() => { toggleClick(4) }}>
          <FooterTitleMobile>給我們意見</FooterTitleMobile>
          <FooterIconMobile $isOpen={isOpenMenu4} />
        </FooterTitleContainerMobile>

        <CSSTransition
          in={isOpenMenu4}
          timeout={250}
          classNames="slide"
          unmountOnExit
        >
          <FooterContentMobile>
            <Flex>
              <img src={`${process.env.PUBLIC_URL}/images/feedback.png`} alt="feedback" />
              <FooterLink href="https://www.bluecross.com.hk/cn/Contact-Us/Online-Enquiry">意見/查詢</FooterLink>
            </Flex>
            <img src={`${process.env.PUBLIC_URL}/images/AppCode.png`} alt="QR code" />
          </FooterContentMobile>
        </CSSTransition>

        <FooterTitleContainerMobile onClick={() => { toggleClick(5) }}>
          <FooterTitleMobile>法律聲明</FooterTitleMobile>
          <FooterIconMobile $isOpen={isOpenMenu5} />
        </FooterTitleContainerMobile>

        <CSSTransition
          in={isOpenMenu5}
          timeout={250}
          classNames="slide"
          unmountOnExit
        >
          <FooterContentMobile>
            <FooterLink href="https://ap.bluecross.com.hk/Routing/document/general/Disclaimer/cn">免責聲明</FooterLink>
            <FooterLink href="https://ap.bluecross.com.hk/Routing/document/general/dividend_statement/cn">紅利聲明</FooterLink>
            <FooterLink href="https://ap.bluecross.com.hk/Routing/document/general/levy_collection/cn">保險業監管局保費徵費</FooterLink>
            <FooterLink href="https://ap.bluecross.com.hk/Routing/document/general/pics_bcaia/cn">收集個人資料聲明</FooterLink>
            <FooterLink href="https://ap.bluecross.com.hk/Routing/document/general/eprivacy/cn">私隱政策聲明</FooterLink>
          </FooterContentMobile>
        </CSSTransition>

        <Space />

        <FormText>版權 © 2024，藍十字（亞太）保險有限公司。版權所有，不得轉載。</FormText>

        <Space height={20} />

        <Flex>
          <SocialButton href="https://www.facebook.com/BlueCrossHK/" target="_blank">
            <img src={`${process.env.PUBLIC_URL}/images/fb.png`} alt="fb" />
          </SocialButton>
          <SocialButton href="https://www.instagram.com/bluecrosshk" target="_blank">
            <img src={`${process.env.PUBLIC_URL}/images/Instagram.png`} alt="Instagram" />
          </SocialButton>
          <SocialButton href="https://www.youtube.com/channel/UC6_r0jCRF9iMXod58WwQYzQ" target="_blank">
            <img src={`${process.env.PUBLIC_URL}/images/Youtube.png`} alt="Youtube" />
          </SocialButton>
          <SocialButton href="https://www.linkedin.com/company/blue-cross-asia-pacific-insurance-limited" target="_blank">
            <img src={`${process.env.PUBLIC_URL}/images/Linkedin.png`} alt="Linkedin" />
          </SocialButton>
        </Flex>
      </BXFooterMobile>
    )
  }

  return (
    <BXFooter>
      <Flex alignItems={"flex-start"} style={{ margin: "30px 0px", gap: 20 }}>
        <Flex flex={2} direction={"column"} alignItems={"flex-start"} style={{ gap: 5 }}>
          <FooterTitle>關於藍十字</FooterTitle>
          <FooterLink href="https://www.bluecross.com.hk/cn/AboutBlueCross/Information/CompanyProfile">公司簡介</FooterLink>
          <FooterLink href="https://www.bluecross.com.hk/cn/AboutBlueCross/Information/CompanyNews">公司動向</FooterLink>
          <FooterLink href="https://www.bluecross.com.hk/cn/AboutBlueCross/Information/SocialResponsibility">企業社會責任</FooterLink>
          <FooterLink href="https://www.bluecross.com.hk/cn/Fencing/Information">全力支持劍擊運動</FooterLink>
          <FooterLink href="https://www.bluecross.com.hk/cn/AboutBlueCross/Information/NewsRoom">新聞中心</FooterLink>
          <FooterLink href="https://www.bluecross.com.hk/cn/AboutBlueCross/Information/InTheNews">傳媒報導</FooterLink>
          <FooterLink href="https://www.bluecross.com.hk/cn/AboutBlueCross/Information/VideoReview">片段重溫</FooterLink>
          <FooterLink href="https://www.bluecross.com.hk/cn/AboutBlueCross/Information/CompanyAwards">公司獎項</FooterLink>
          <FooterLink href="https://www.bluecross.com.hk/cn/career-opportunities/Information">就業機會</FooterLink>
        </Flex>
        <Flex flex={3} direction={"column"} alignItems={"flex-start"} style={{ gap: 5 }}>
          <FooterTitle>聯絡我們</FooterTitle>
          <Flex>
            <FooterIcon>
              <img src={`${process.env.PUBLIC_URL}/images/call.png`} alt="call" />
            </FooterIcon>
            <FooterLink href="tel:+85228396333">電話：(852) 2839 6333</FooterLink>
          </Flex>
          <Flex>
            <FooterIcon>
              <img src={`${process.env.PUBLIC_URL}/images/email.png`} alt="email" />
            </FooterIcon>
            <FooterLink href="mailto:CS@bluecross.com.hk">電郵：CS@bluecross.com.hk</FooterLink>
          </Flex>
          <Flex>
            <FooterIcon>
              <img src={`${process.env.PUBLIC_URL}/images/fax.png`} alt="fax" />
            </FooterIcon>
            <FooterText>傳真：(852) 2263 7517</FooterText>
          </Flex>
          <Flex>
            <FooterIcon style={{ marginTop: 7 }}>
              <img src={`${process.env.PUBLIC_URL}/images/clock.png`} alt="clock" />
            </FooterIcon>
            <FooterTitle style={{ marginBottom: 0 }}>客戶服務時間</FooterTitle>
          </Flex>
          <FooterText>星期一至星期五</FooterText>
          <FooterText>上午9時至下午5時30分</FooterText>
          <FooterText>星期六、日及公眾假期休息</FooterText>
          <Flex>
            <FooterIcon style={{ marginTop: 7 }}>
              <img src={`${process.env.PUBLIC_URL}/images/address.png`} alt="address" />
            </FooterIcon>
            <FooterTitle style={{ marginBottom: 0 }}>地址:</FooterTitle>
          </Flex>
          <FooterText>香港灣仔皇后大道東183號</FooterText>
          <FooterText>合和中心54樓</FooterText>
        </Flex>
        <Flex flex={2} direction={"column"} alignItems={"flex-start"} style={{ gap: 5 }}>
          <FooterTitle>網誌</FooterTitle>
          <FooterLink href="https://just-right.bluecross.com.hk/blog/all">所有主題</FooterLink>
          <FooterLink href="https://just-right.bluecross.com.hk/blog/health">健康智識</FooterLink>
          <FooterLink href="https://just-right.bluecross.com.hk/blog/life">智式生活</FooterLink>
          <FooterLink href="https://just-right.bluecross.com.hk/blog/pet">智寵您</FooterLink>
          <FooterLink href="https://just-right.bluecross.com.hk/blog/travel">智遊天下</FooterLink>
          <FooterLink href="https://just-right.bluecross.com.hk/blog/protection">保障啱啱好</FooterLink>
        </Flex>
        <Flex flex={3} direction={"column"} alignItems={"flex-start"} style={{ gap: 5 }}>
          <FooterTitle>給我們意見</FooterTitle>
          <Flex>
            <img src={`${process.env.PUBLIC_URL}/images/feedback.png`} alt="feedback" />
            <FooterLink href="https://www.bluecross.com.hk/cn/Contact-Us/Online-Enquiry">意見/查詢</FooterLink>
          </Flex>
          <Space height={40} />
          <img src={`${process.env.PUBLIC_URL}/images/AppCode.png`} alt="QR code" />
          <Space height={10} />
          <Flex>
            <SocialButton href="https://www.facebook.com/BlueCrossHK/" target="_blank">
              <img src={`${process.env.PUBLIC_URL}/images/fb.png`} alt="fb" />
            </SocialButton>
            <SocialButton href="https://www.instagram.com/bluecrosshk" target="_blank">
              <img src={`${process.env.PUBLIC_URL}/images/Instagram.png`} alt="Instagram" />
            </SocialButton>
            <SocialButton href="https://www.youtube.com/channel/UC6_r0jCRF9iMXod58WwQYzQ" target="_blank">
              <img src={`${process.env.PUBLIC_URL}/images/Youtube.png`} alt="Youtube" />
            </SocialButton>
            <SocialButton href="https://www.linkedin.com/company/blue-cross-asia-pacific-insurance-limited" target="_blank">
              <img src={`${process.env.PUBLIC_URL}/images/Linkedin.png`} alt="Linkedin" />
            </SocialButton>
          </Flex>
        </Flex>
        <Flex flex={3} direction={"column"} alignItems={"flex-start"} style={{ gap: 5 }}>
          <FooterTitle>法律聲明</FooterTitle>
          <FooterLink href="https://ap.bluecross.com.hk/Routing/document/general/Disclaimer/cn">免責聲明</FooterLink>
          <FooterLink href="https://ap.bluecross.com.hk/Routing/document/general/dividend_statement/cn">紅利聲明</FooterLink>
          <FooterLink href="https://ap.bluecross.com.hk/Routing/document/general/levy_collection/cn">保險業監管局保費徵費</FooterLink>
          <FooterLink href="https://ap.bluecross.com.hk/Routing/document/general/pics_bcaia/cn">收集個人資料聲明</FooterLink>
          <FooterLink href="https://ap.bluecross.com.hk/Routing/document/general/eprivacy/cn">私隱政策聲明</FooterLink>
        </Flex>
      </Flex>

      <Divider marginVertical={10} />
      <FormText>版權 © 2024，藍十字（亞太）保險有限公司。版權所有，不得轉載。</FormText>
    </BXFooter>
  );
};

const BXFooterMobile = styled.footer`
  width: 100%;
  padding: 0px 15px;
`;

const FooterTitleContainerMobile = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 15px;
  border-bottom: 1px solid var(--aia-bx-gray-4);
  cursor: pointer;
`;

const FooterTitleMobile = styled.div`
  color: var(--aia-bx-gray-50);
  font-size: 16px;
`;

const FooterIconMobile = styled.div`
  pointer-events: none;
  content: url(${process.env.PUBLIC_URL}/images/chevron-d.svg);
  height: 24px;
  width: 24px;
  top: 8px;
  transition: transform 0.2s ease-in-out;
  transform: ${props => props.$isOpen ? 'rotate(-180deg)' : 'rotate(0deg)'};
`;

const FooterContentMobile = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 15px;
  gap: 8px;
  border-bottom: 1px solid var(--aia-bx-gray-4);
`;

const BXFooter = styled.footer`
  max-width: 1200px;
  width: 95%;
  box-shadow: 0px -0.25rem 0.25rem 0px rgba(0, 150, 238, 0.05);
`;

const FooterTitle = styled.div`
  font-size: 16px;
  font-weight: bold;
  margin: 5px 0px;
  color: var(--aia-bx-gray);
`;

const FooterText = styled.div`
  font-size: 14px;
  color: var(--aia-bx-gray);
`;

const FooterLink = styled.a`
  font-size: 14px;
  color: var(--aia-bx-gray);
  text-decoration: none;
`;

const FooterIcon = styled.div`
  width: 20px;
  display: flex;
`;

const SocialButton = styled.a`
  background-color: transparent;
  border: 1px solid var(--aia-bx-dark-blue);
  cursor: pointer;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  align-items: center;
  display: flex;
  justify-content: center;

  &:hover {
    background-color: var(--aia-bx-blue-4);
  }
`;

export default Footer;